module.exports = __webpack_public_path__ + "static/media/social1.72031ae6.png";